import { create } from 'zustand';
import { InterviewStore, InterviewConfig, InterviewQuestion } from './types';

const defaultConfig: InterviewConfig = {
  language: 'en',
  tone: 'formal',
  technicalDepth: 'intermediate',
  duration: 5,
  questionTypes: ['technical', 'behavioral', 'situational'],
  customQuestions: [],
  yearsOfExperience: 3,
  salaryRange: {
    min: 50000,
    max: 100000
  },
  turnoverRate: 'low',
  model: 'gpt-3.5-turbo',
  temperature: 0.7,
  maxTokens: 1000,
  voice: {
    gender: 'female',
    pitch: 1.1,
    rate: 0.9
  }
};

export const useInterviewStore = create<InterviewStore>((set) => ({
  jobDescription: null,
  currentInterview: null,
  interviews: [],
  interviewConfig: defaultConfig,
  setJobDescription: (jd) => set({ jobDescription: jd }),
  setCurrentInterview: (interview) => set({ currentInterview: interview }),
  addInterview: (interview) =>
    set((state) => ({ interviews: [...state.interviews, interview] })),
  updateInterview: (id, interview) =>
    set((state) => ({
      interviews: state.interviews.map((i) =>
        i.id === id ? { ...i, ...interview } : i
      ),
      currentInterview: state.currentInterview?.id === id
        ? { ...state.currentInterview, ...interview }
        : state.currentInterview
    })),
  updateConfig: (config) =>
    set((state) => ({
      interviewConfig: { 
        ...state.interviewConfig, 
        ...config,
        voice: {
          ...state.interviewConfig.voice,
          ...config.voice,
          gender: 'female'
        }
      }
    })),
  setInterviewQuestions: (id, questions) =>
    set((state) => ({
      interviews: state.interviews.map((i) =>
        i.id === id ? { ...i, questions } : i
      ),
      currentInterview: state.currentInterview?.id === id
        ? { ...state.currentInterview, questions }
        : state.currentInterview
    }))
}));